import { SITE_CONFIG } from "../app/config";
import { LegalLayout } from "./LegalLayout";

export const AffiliatePage = (): JSX.Element => (
  <LegalLayout title="Affiliate Disclosure" path="/affiliate-disclosure">
    <section>
      <h2>Overview</h2>
      <p>
        {SITE_CONFIG.name} is committed to transparency. This page explains our affiliate relationships 
        and how we earn revenue to keep the Service free for users.
      </p>
    </section>

    <section>
      <h2>What Are Affiliate Links?</h2>
      <p>
        Affiliate links are special URLs that track when visitors click through and make purchases. 
        When you buy a product through one of our affiliate links, we receive a small commission from 
        the retailer. <strong>This does not affect the price you pay</strong> – you pay the same amount 
        whether you use our link or go directly to the retailer.
      </p>
    </section>

    <section>
      <h2>Our Affiliate Partnerships</h2>
      
      <h3>{SITE_CONFIG.affiliatePartner}</h3>
      <p>
        {SITE_CONFIG.name} is a participant in the {SITE_CONFIG.affiliatePartner} affiliate program. 
        When you click on CD or vinyl purchase links and complete a purchase on {SITE_CONFIG.affiliatePartner}, 
        we may earn a commission.
      </p>
      <p>
        {SITE_CONFIG.affiliatePartner} is a marketplace specializing in physical music formats including 
        CDs, vinyl records, and other collectibles. We chose to partner with them because of their 
        extensive catalog and commitment to the physical music community.
      </p>
    </section>

    <section>
      <h2>How This Affects You</h2>
      <ul>
        <li>
          <strong>No Extra Cost:</strong> You never pay more by using our affiliate links. Prices are 
          set by the retailer and are the same whether you use our link or not.
        </li>
        <li>
          <strong>Support the Service:</strong> Affiliate commissions help us keep {SITE_CONFIG.name} 
          free and allow us to continue improving the Service.
        </li>
        <li>
          <strong>Your Choice:</strong> You are never obligated to use our affiliate links. You can 
          always search for products directly on retailer websites.
        </li>
      </ul>
    </section>

    <section>
      <h2>Our Commitment</h2>
      <p>We are committed to:</p>
      <ul>
        <li>
          <strong>Transparency:</strong> Clearly disclosing affiliate relationships on pages with 
          affiliate links.
        </li>
        <li>
          <strong>Honesty:</strong> Never recommending products solely for commission. Our Service 
          simply helps you find where to buy music you already love.
        </li>
        <li>
          <strong>User-First:</strong> Providing accurate, helpful information regardless of affiliate 
          relationships.
        </li>
      </ul>
    </section>

    <section>
      <h2>FTC Compliance</h2>
      <p>
        In accordance with the Federal Trade Commission (FTC) guidelines on endorsements and testimonials, 
        we disclose our affiliate relationships:
      </p>
      <ul>
        <li>On every page containing affiliate links</li>
        <li>Near the affiliate links themselves</li>
        <li>In this comprehensive disclosure page</li>
      </ul>
      <p>
        We believe in full transparency with our users about how we generate revenue.
      </p>
    </section>

    <section>
      <h2>Questions?</h2>
      <p>
        If you have any questions about our affiliate relationships or this disclosure, please contact 
        us at <a href={`mailto:${SITE_CONFIG.contactEmail}`}>{SITE_CONFIG.contactEmail}</a>.
      </p>
    </section>
  </LegalLayout>
);


